<!-- eslint-disable vue/valid-template-root -->
<template lang="html">
  <Col :span="12">
  <Card class="card-box">
    <div class="text-center" v-if="isLongHaulDeliveryVsEtaLoading">
      <Spinner />
    </div>
    <div class="status-msg" v-else-if="!dashboardConfigsDetails">
      <span>
        <svgicon :name="emptyDashboardIcon" width="150" height="115" :original="true" />
        <p class="mt-0 ml-30">No data available</p>
      </span>
    </div>
    <Row :gutter="40" v-else>
      <Col :span="24">
      <div class="header-text">
        Delivery vs ETA - Long Haul
      </div>
      <Graph :graphDetail="dashboardConfigsGraphDetails" :headerConstant="etaBarChartConstants">
      </Graph>
      </Col>

      <Col :span="24">
      <Row :gutter="40" class="list-bordered divider col-pt-15 mt-30">
        <Col :span="12" v-for="header in deliveryVsEtaLongHaul" :key="header.id" :class="header.class">
        <Tooltip :open-delay="100" popper-class="max-width" effect="dark" placement="top">
          <div slot="content">
            <span v-html="getRangeData(header.type, header.column)"></span>
          </div>
          <ColCell :header="header" :value="dashboardConfigsDetails[header.column]"
            @routeToTrack="$emit('routeToTrack', { routeCategory: header.routeCategory, type: header.type, header: $event })">
          </ColCell>
        </Tooltip>
        </Col>
      </Row>

      </Col>
    </Row>
  </Card>
  </Col>
</template>

<script>
import ColCell from '@/components/track/ColCell';
import Graph from '@/components/track/Graph';
import { cloneDeep } from 'lodash';
import {
  deliveryVsEtaLongHaul,
  etaDetailsHeaders,
  etaBarChartConstants,
} from '@/constants/trackConstants';
import SecFilterMixin from '@common/mixins/SecFilterMixin';

export default {
  components: {
    ColCell,
    Graph,
  },
  mixins: [SecFilterMixin],
  data() {
    return {
      etaDetailsHeaders,
      etaBarChartConstants,
      deliveryVsEtaLongHaul,
      longHaulDeliveryVsEta: null,
      isLongHaulDeliveryVsEtaLoading: true,
      fromToData: {},
    };
  },
  props: ['queryParams', 'dashboardConfigs', 'apiTrigger', 'emptyDashboardIcon', 'trackingDashboard'],
  async created() {
    this.apiTrigger.$on('loadMore', (args) => {
      this.search();
    });
  },
  computed: {
    dashboardConfigsDetails() {
      const longHaul = this.dashboardConfigs.widgets.long_haul_delivery_vs_eta;
      deliveryVsEtaLongHaul[0].description = longHaul.early.range ? `Between ${longHaul.early.from_hour} Hrs & ${longHaul.early.to_hour} Hrs` : `Before ${longHaul.early.from_hour} Hrs`;
      deliveryVsEtaLongHaul[1].description = longHaul.on_time.range ? `Between ${longHaul.on_time.from_hour} Hrs & ${longHaul.on_time.to_hour} Hrs` : `Before ${longHaul.on_time.from_hour} Hrs`;
      deliveryVsEtaLongHaul[2].description = longHaul.late.range ? `Between ${longHaul.late.from_hour} Hrs & ${longHaul.late.to_hour} Hrs` : `More than ${longHaul.late.from_hour} Hrs`;
      deliveryVsEtaLongHaul[3].description = longHaul.very_late.range ? `Between ${longHaul.very_late.from_hour} Hrs & ${longHaul.very_late.to_hour} Hrs` : `More than ${longHaul.very_late.from_hour} Hrs`;
      return this.longHaulDeliveryVsEta;
    },
    dashboardConfigsGraphDetails() {
      const graphData = {
        early: this.longHaulDeliveryVsEta.early,
        late: this.longHaulDeliveryVsEta.late,
        onTime: this.longHaulDeliveryVsEta.onTime,
        veryLate: this.longHaulDeliveryVsEta.veryLate,
      };
      return graphData;
    },
  },

  methods: {
    async search() {
      const resultObj = 'longHaulDeliveryVsEta';
      const loadingObj = 'isLongHaulDeliveryVsEtaLoading';
      const section = 'longHaulDeliveryVsEta';
      const params = this.queryParams;
      this[loadingObj] = true;
      const result = await this.$store.dispatch('track/getDashboardDetails', { section, params });
      if (result && !result.error) {
        this[resultObj] = result;
      } else {
        this[resultObj] = null;
      }
      this[loadingObj] = false;
    },
    getRangeData(type, column) {
      const longHaul = this.dashboardConfigs.widgets.long_haul_delivery_vs_eta;
      this.fromToData[type] = longHaul[type].range ?
        [longHaul[type].from_hour, longHaul[type].to_hour] : [longHaul[type].from_hour];
      let processData = cloneDeep(this.trackingDashboard && this.trackingDashboard[`delivery${column}LongHaul`]);
      this.fromToData[type].forEach((data, index) => {
        processData = processData.replaceAll(`{${index + 1}}`, data);
      });
      return processData;
    },
  },
};
</script>
